define('model/previous.reviewer.model',['require','exports','module','underscore','fukit','datakit/datakit'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      BaseModel = require('fukit').BaseModel,
      DataKit   = require('datakit/datakit');

  var PreviousReviewrModel = BaseModel.extend({
    radioRequests: {
      'models PreviousReviewrModel': '@constructor',
    },

    updateUrl: function(urlTemplate) {
      var url = DataKit.url.template(urlTemplate, this);

      //shit gets ugly if we don't unset the taskId from the model before we fetch or save
      this.unset('taskId');
      return url;
    },

    parse: function(data, xhr) {
      if (_.isArray(data)) {
        data = _.extend({}, data[0]);
      }
      return data;
    },

    fetchUrlTemplate: '/api/v1/coi-workflow/runtime/tasks/:taskId/identitylinks/users',

    saveUrlTemplate: '/api/v1/coi-workflow/runtime/tasks/:taskId/identitylinks',

    fetch: function(options) {
      return BaseModel.prototype.fetch.call(
        this,
        _.extend(
          {
            url: this.updateUrl(this.fetchUrlTemplate),
          },
          options
        )
      );
    },

    save: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            url: this.updateUrl(this.saveUrlTemplate),
            type: 'POST',
          },
          options
        )
      );
    },
  });

  module.exports = PreviousReviewrModel;
});

